import script from "./WatchlistOrderView.vue?vue&type=script&setup=true&lang=ts"
export * from "./WatchlistOrderView.vue?vue&type=script&setup=true&lang=ts"

import "./WatchlistOrderView.vue?vue&type=style&index=0&id=24443fef&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24443fef"]])

export default __exports__